export const AGENT_ENDPOINTS = {
  copilot: {
    path: '/v1/chat',
    id: 'copilot',
  },
  tooltip: {
    path: '/v1/tooltips',
    id: 'tooltip',
  },
  suggestActivities: {
    path: '/v1/suggest/activities',
  },
};
